import { useState, useEffect } from 'react';

function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export default function InstallButton() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    if (!isMobileDevice()) {
      setIsVisible(false);
      return;
    }

    // Detect iOS
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
                (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    setIsIOS(iOS);

  // Detect Chrome on Android (unused) - intentionally not stored to avoid lint warning

    // Listen for the PWA install prompt event
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', () => setIsVisible(false));

    // Rendi il pulsante sempre visibile su mobile
    setIsVisible(true);

    // Clean up
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setIsVisible(false);
      }
      setDeferredPrompt(null);
    } else if (isIOS) {
      alert(
        "Per scaricare l'app su iPhone/iPad:\n" +
        "1. Tocca il pulsante Condividi (quello con la freccia in alto).\n" +
        "2. Scorri verso il basso e seleziona 'Aggiungi a Home'.\n" +
        "3. Conferma il nome e tocca 'Aggiungi'."
      );
    } else {
      alert(
        "Per scaricare l'app:\n" +
        "1. Apri il menu del browser.\n" +
        "2. Seleziona 'Aggiungi a schermata Home' o 'Installa App'.\n" +
        "Se non vedi questa opzione, aggiorna il browser o prova con Chrome su Android."
      );
    }
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={handleInstallClick}
      style={{
        padding: '0.5rem 1rem',
        background: 'linear-gradient(135deg, rgb(252, 218, 26) 0%, rgb(245, 202, 61) 100%)',
        border: '1px solid #000',
        color: '#000',
        fontWeight: '500',
        cursor: 'pointer',
        fontSize: '1.25rem',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '0.375rem',
        transition: 'all 0.2s ease'
      }}
    >
      <i className="bi bi-download" style={{ marginRight: 8 }}></i>
      Installa App
    </button>
  );
} 